import {
  Box,
  useDisclosure,
  Flex,
  ButtonGroup,
  useColorModeValue
} from '@chakra-ui/react';
import { useContext, useEffect, useState } from 'react';
import PageHeader from '../../components/common/PageHeader';
import AddButton from '../../components/custom/AddButton';
import LinkButton from '../../components/custom/LinkButton';
import { UserInfoContext } from '../../provider/UserInfoProvider';
import { UseConstant } from '../../libraries/UseConstant';
import { UseMessage } from '../../libraries/UseMessage';
import { UseApi } from '../../libraries/UseApi';
import Loading from '../../components/common/Loading';
import NoData from '../../components/common/NoData';
import UserTechnologyTable from '../../components/tables/UserTechnologyTable';

export default function MyTechnologies() {
    const [technologies, setTechnologies] = useState([]);
    // ページ番号
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const { onOpen } = useDisclosure();

    const [isProcessing, setIsProcessing] = useState(false);

    const {token} = useContext(UserInfoContext);
    const {constant} = UseConstant();
    const {Message} = UseMessage();
    const {TECHNOLOGY_LIST} = constant;

    const { getApi } = UseApi();
    
    const cardBg = useColorModeValue('whiteAlpha.800', 'whiteAlpha.100');

    const [selectedTechId, setSelectedTechId] = useState(null);
    console.log('selectedTechId', selectedTechId);

    useEffect(() => {
        getTechnologies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[currentPageNo]);

    const getTechnologies = () => {
        // 処置中チェック
        if (isProcessing) {
            // 処理中の場合、以降の処理を実施しない
            return;
        }
        // 処理中フラグをONにする
        setIsProcessing(true);

        // 検索パラメータ
        let paging = {
            limit: TECHNOLOGY_LIST,
            offset: currentPageNo - 1
        };
        let params = { ...paging };

        // 未受検者検索API
        getApi(
            `${process.env.REACT_APP_API_URL}/me/technologies`, params, { token: token },
            (response) => {
                // 成功時
                if (response.isSuccess === false) {
                    // error
                    alert(Message.Common.ERROR);
                    // 処理中フラグを元に戻す
                    setIsProcessing(false);
                    return;
                }

                setTechnologies(response.data?.technologies || []);
                setTotalPages(Math.ceil(response.data?.total / paging?.limit));
                // 処理中フラグを元に戻す
                setIsProcessing(false);
            },
            () => {
                // 異常時
                // 処理中フラグをOFFにする
                setIsProcessing(false);
            }
        );
    };

    const handlePageChange = (page) => {
        setCurrentPageNo(page);
    }

    return (
        <Box
            px={{ base: 2, md: 5 }}
            py={4}
            bgGradient="linear(to-br, orange.50, white)"
            minH="100vh"
            w="full"
        >
            {/* Page Header */}
            <Flex
                justify="space-between"
                align="center"
                mb={5}
                flexWrap="wrap"
                gap={4}
            >
                <PageHeader headerTitle={'技術一覧'} />
                <ButtonGroup>
                    <AddButton buttonText="新規登録" buttonUrl="/add-self-technology" />
                    <LinkButton buttonText="戻る" buttonUrl="/user-dashboard" />
                </ButtonGroup>
            </Flex>

            {/* Gorgeous Container */}
            <Box
                bg={cardBg}
                boxShadow="xl"
                backdropFilter="blur(10px)"
                p={{ base: 4, md: 8 }}
            >

                {/* Content */}
                {isProcessing ? (
                    <Loading />
                ) : technologies.length === 0 ? (
                    <NoData />
                ) : (
                    <UserTechnologyTable
                        technologies={technologies}
                        onDelete={(id) => {
                            setSelectedTechId(id);
                            onOpen();
                        }}
                        onPageChange={handlePageChange}
                        currentPageNo={currentPageNo}
                        totalPages={totalPages}
                    />
                )}
            </Box>
        </Box>
    );
}
